import React from "react";
import { Outlet } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import SiteHeader from "@/components/site/SiteHeader";
import SiteFooter from "@/components/site/SiteFooter";

export default function SiteLayout() {
  const { site, loading } = useSite();
  if (loading || !site) {
    return <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7] text-[#4A5550]">Loading…</div>;
  }
  return (
    <div className="min-h-screen flex flex-col bg-[#FDFBF7] text-[#1A201D] grain relative">
      <SiteHeader settings={site.settings} header={site.header} />
      <main className="flex-1 relative z-10">
        <Outlet context={{ site }} />
      </main>
      <SiteFooter settings={site.settings} footer={site.footer} />
    </div>
  );
}
